export default "__VITE_ASSET__CmR5K$lc__"